import { AtlassianIcon } from '@atlaskit/logo';
import React from 'react';
import styled from 'styled-components';

import ProductCard from './ProductCard';

const dummyProduct = {
  cloudId: 'cloudId',
  count: 0,
  icon: AtlassianIcon,
  productName: 'productName',
  siteName: 'siteName',
  url: 'url',
};

const HiddenProductCard = styled(ProductCard).attrs({
  tabIndex: -1,
})`
  opacity: 0;
  pointer-events: none;
`;

interface Props {
  maxCardsPerRow: number;
  productsCount: number;
}

export default class InvisibleCardList extends React.PureComponent<Props> {
  render() {
    const { productsCount, maxCardsPerRow } = this.props;

    const remainder = productsCount % maxCardsPerRow;
    if (remainder === 0) {
      return null;
    }
    const hiddenCards = [];
    const cardToAdd = maxCardsPerRow - remainder;
    for (let i = 0; i < cardToAdd; i++) {
      hiddenCards.push(
        <HiddenProductCard
          data-test-id="invisible-card"
          key={`invisible-${name}-${i}`}
          aria-hidden="true"
          {...dummyProduct}
          fullScreen
          hideSiteName={true}
        />,
      );
    }
    return hiddenCards;
  }
}
